<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.is-has
          .column.is-fullwidth
            h3.title.has-text-centered
              | Historial del Artículo
              | &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
            br
        .columns
          .column
            .timeline.is-centered
              header.timeline-header
                span.tag.is-medium.is-primary Inicio
              TimelineItem(v-for="data in dataHistorias" :movimiento="data" :key="data.id")
              header.timeline-header
                span.tag.is-medium.is-primary Fin
</template>

<script>
import Loader from '../shared/Loader.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import TimelineItem from '@/components/inventario_Componentes/TimelineItem.vue'

export default {
  name: 'Historia',
  components: { Loader, NavBarInventario, TimelineItem },
  data () {
    return {
      isLoading: false,
      idArticulo: '',
      historia: [],
      historiaCompra: [],
      dataHistorias: [],
      classTimeline: {
        0: 'timeline-item is-primary is-icon',
        1: 'timeline-item is-danger is-icon',
        2: 'timeline-item is-warning is-icon'
      }
    }
  },
  methods: {
    obtenerDataHistoria() {
      this.idArticulo= this.$route.params.id

      InventarioServices.getHistoriaCompra(this.idArticulo)
        .then( resp => {

          if (resp.length > 0) {
            const dataHistoriaCompra = this.convertirHistoria(resp[0])
            console.log(dataHistoriaCompra)
  
            let objT_creada = {}       // T-0
            let objT_atendida = {}     // T-1
            let objT_aceptada = {}     // T-3
            let objT_autorizada = {}   // T-5
            let objT_inCompra = {}      // T-6
            let objT_firmaGP = {}      // T-7
            let objT_firmaJA = {}      // T-8
            let objT_firmaRev = {}      // T-9
            let objT_firmaAu = {}      // T-10
            
            objT_creada = {
              fechaReg: dataHistoriaCompra.fecha_registro,
              usuario: dataHistoriaCompra.tipo === 1 ? dataHistoriaCompra.dataTicket.t_solicita : dataHistoriaCompra.dataSolicitud.s_solicita,
              ubicacion: dataHistoriaCompra.tipo === 1 ? dataHistoriaCompra.dataTicket.t_ubicacion : dataHistoriaCompra.dataSolicitud.s_ubicacion,
              tipo: dataHistoriaCompra.tipo === 1 ? 't' : 's',
              momento: dataHistoriaCompra.tipo === 1 ? 0 : 3,
            }
  
            objT_atendida = {
              fechaReg: dataHistoriaCompra.fecha_atendido,
              usuario: dataHistoriaCompra.tipo === 1 ? dataHistoriaCompra.dataTicket.t_resuelve : dataHistoriaCompra.dataSolicitud.s_solicita,
              ubicacion: dataHistoriaCompra.tipo === 1 ? dataHistoriaCompra.dataTicket.t_ubicacion : dataHistoriaCompra.dataSolicitud.s_ubicacion,
              tipo: dataHistoriaCompra.tipo === 1 ? 't' : 's',
              momento: dataHistoriaCompra.tipo === 1 ? 1 : 3
            }
  
            objT_aceptada = {
              fechaReg: dataHistoriaCompra.fecha_aceptada,
              usuario: dataHistoriaCompra.tipo === 1 ? dataHistoriaCompra.dataTicket.t_acepta_compra : dataHistoriaCompra.dataSolicitud.s_solicita,
              ubicacion: dataHistoriaCompra.tipo === 1 ? dataHistoriaCompra.dataTicket.t_ubicacion : dataHistoriaCompra.dataSolicitud.s_ubicacion,
              tipo: dataHistoriaCompra.tipo === 1 ? 't' : 's',
              momento: dataHistoriaCompra.tipo === 1 ? 3 : 3
            }
  
            objT_autorizada = {
              fechaReg: dataHistoriaCompra.fecha_autorizada,
              usuario: dataHistoriaCompra.tipo === 1 ? dataHistoriaCompra.dataTicket.t_autoriza_compra : dataHistoriaCompra.dataSolicitud.s_solicita,
              ubicacion: dataHistoriaCompra.tipo === 1 ? dataHistoriaCompra.dataTicket.t_ubicacion : dataHistoriaCompra.dataSolicitud.s_ubicacion,
              tipo: dataHistoriaCompra.tipo === 1 ? 't' : 's',
              momento: dataHistoriaCompra.tipo === 1 ? 5 : 3
            }
  
            objT_inCompra = {
              fechaReg: dataHistoriaCompra.fecha_autorizada,
              usuario: dataHistoriaCompra.r_usuario_reg,
              ubicacion: dataHistoriaCompra.tipo === 1 ? dataHistoriaCompra.dataTicket.t_ubicacion : dataHistoriaCompra.dataSolicitud.s_ubicacion,
              tipo: dataHistoriaCompra.tipo === 1 ? 't' : 's',
              momento: dataHistoriaCompra.tipo === 1 ? 6 : 4
            }
  
            objT_firmaGP = {
              fechaReg: dataHistoriaCompra.fecha_req_firma_gp,
              usuario: dataHistoriaCompra.r_user_GP,
              ubicacion: dataHistoriaCompra.r_ubicacion,
              tipo: dataHistoriaCompra.tipo === 1 ? 't' : 's',
              momento: dataHistoriaCompra.tipo === 1 ? 7 : 5
            }
  
            objT_firmaJA = {
              fechaReg: dataHistoriaCompra.fecha_req_firma_ja,
              usuario: dataHistoriaCompra.r_user_JA,
              ubicacion: dataHistoriaCompra.r_ubicacion,
              tipo: dataHistoriaCompra.tipo === 1 ? 't' : 's',
              momento: dataHistoriaCompra.tipo === 1 ? 8 : 6
            }
            
            objT_firmaRev = {
              fechaReg: dataHistoriaCompra.fecha_req_firma_rev,
              usuario: dataHistoriaCompra.r_user_Rev,
              ubicacion: dataHistoriaCompra.r_ubicacion,
              tipo: dataHistoriaCompra.tipo === 1 ? 't' : 's',
              momento: dataHistoriaCompra.tipo === 1 ? 9 : 7
            }
  
            objT_firmaAu = {
              fechaReg: dataHistoriaCompra.fecha_req_firma_au,
              usuario: dataHistoriaCompra.r_user_AU,
              ubicacion: dataHistoriaCompra.r_ubicacion,
              tipo: dataHistoriaCompra.tipo === 1 ? 't' : 's',
              momento: dataHistoriaCompra.tipo === 1 ? 10 : 8
            }
  
            if (dataHistoriaCompra.tipo === 1) {
              this.historiaCompra.push(objT_creada)
              this.historiaCompra.push(objT_atendida)
              this.historiaCompra.push(objT_aceptada)
              this.historiaCompra.push(objT_autorizada)
              this.historiaCompra.push(objT_inCompra)
              this.historiaCompra.push(objT_firmaGP)
              this.historiaCompra.push(objT_firmaJA)
              this.historiaCompra.push(objT_firmaRev)
              this.historiaCompra.push(objT_firmaAu)
            } else {
              this.historiaCompra.push(objT_autorizada)
              this.historiaCompra.push(objT_inCompra)
              this.historiaCompra.push(objT_firmaGP)
              this.historiaCompra.push(objT_firmaJA)
              this.historiaCompra.push(objT_firmaRev)
              this.historiaCompra.push(objT_firmaAu)
            }

          }

          InventarioServices.getHistoria(this.idArticulo)
            .then(data => {
              console.log(data)
              this.historia = data.map(this.agregarSource)
              this.historiaCompra.map(item => this.dataHistorias.push(item))
              this.historia.map( item => this.dataHistorias.push(item))
            })
            .catch( e => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
            })
        })
        .catch( e => {
          this.isLoading = false
          this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
        })

      
    },

    agregarSource (hist) {
      return {
        ...hist,
        source: 'inv'
      }
    },

    convertirHistoria (compra) {
      return {
        ...compra,
        area: parseInt(compra.area),
        departamento_t: parseInt(compra.departamento_t),
        id: parseInt(compra.id),
        id_item: parseInt(compra.id_item),
        id_req: parseInt(compra.id_req),
        id_req_item: parseInt(compra.id_req_item),
        tipo: parseInt(compra.tipo)
      }

    },
    backPage () {
      this.$router.back()
    },  
    displayToast(text, icon, actionText) {
      let toast = this.$toasted.show(text, { 
        theme: "toasted-primary", 
        position: "bottom-right", 
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    }
  },

  created () {
    this.obtenerDataHistoria()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/Historia.vue